const Images = {
  allSkies: require("./AllSkiesPLCover.jpg"),
  prismaLand: require("./Prismaland.jpg"),
  sufferInSilence: require("./SufferInSilence.gif"),
  components: require("./Components.png"),
  mataRobots: require("./MataRobots.jpg"),
};

export default Images;
